<template>
    <nav
        class="navbar navbar-expand-lg navbar-absolute"
        :class="{ 'bg-white': showMenu, 'navbar-transparent': !showMenu }"
    >
        <div class="container-fluid">
            <div class="navbar-wrapper">
                <div
                    class="navbar-toggle d-inline"
                    :class="{ toggled: sidebar.showSidebar }"
                >
                    <button
                        type="button"
                        class="navbar-toggler"
                        aria-label="Navbar toggle button"
                        @click="toggleSidebar"
                    >
                        <span class="navbar-toggler-bar bar1"></span>
                        <span class="navbar-toggler-bar bar2"></span>
                        <span class="navbar-toggler-bar bar3"></span>
                    </button>
                </div>
                <span class="navbar-brand">{{ routeName }}</span>
            </div>
        </div>
    </nav>
</template>
<script>
export default {
    computed: {
        routeName() {
            const { title } = this.$route.meta;
            return this.capitalizeFirstLetter(title);
        },
        isRTL() {
            return this.rtl?.isRTL;
        },
    },
    data() {
        return {
            activeNotifications: false,
            showMenu: false,
            searchModalVisible: false,
            searchQuery: '',
            rtl: inject('rtl'),
            sidebar: inject('sidebar'),
        };
    },
    methods: {
        capitalizeFirstLetter(string) {
            return string.charAt(0).toUpperCase() + string.slice(1);
        },
        toggleNotificationDropDown() {
            this.activeNotifications = !this.activeNotifications;
        },
        closeDropDown() {
            this.activeNotifications = false;
        },
        toggleSidebar() {
            this.sidebar.displaySidebar(!this.sidebar.showSidebar);
        },
        hideSidebar() {
            this.sidebar.displaySidebar(false);
        },
        toggleMenu() {
            this.showMenu = !this.showMenu;
        },
    },
};
</script>
<style></style>
